import { Color } from "../Model/Color";
import { ColorRepository } from "../Repository/ColorRepository";

export interface CreateColorUseCase {
  invoke: (data: Color) => Promise<Color[]>;
}

export class CreateColor implements CreateColorUseCase {

  private categoryRepo: ColorRepository;

  constructor(_CategoryRepo: ColorRepository) {
    this.categoryRepo = _CategoryRepo;
  }

  async invoke(data: Color){

    if(!data){
        throw new Error(
            "Your todo should have at leat 2 characters."
          );
    }
     
    const created  = await this.categoryRepo.createColor(data);
    return created;
  }
}